import React, { useState, useEffect } from "react";
import cx from "classnames";

import Navbar from "./Navbar";
import Banner from "./Banner";

import styles from "./index.module.scss";

interface HeaderProps {
  className?: string;
  isScrolled?: boolean;
}

const Header: React.FC<HeaderProps> = ({ className = "", isScrolled }) => {
  const [bannerVisible, setBannerVisible] = useState(true);

  // Listen for banner visibility changes
  useEffect(() => {
    // This function will be called by the Banner component when it's closed
    const handleBannerClose = () => {
      setBannerVisible(false);
    };

    // Add a custom event listener to detect when banner is closed
    window.addEventListener("bannerClosed", handleBannerClose);

    return () => {
      window.removeEventListener("bannerClosed", handleBannerClose);
    };
  }, []);

  return (
    <div id="header" className={cx(styles.Header, className)}>
      {bannerVisible && <Banner onClose={() => setBannerVisible(false)} />}
      <Navbar isScrolled={isScrolled} />
    </div>
  );
};

export default Header;
